module.exports = __webpack_public_path__ + "img/knight.58fb6753.png";